<app-waiting
  [startAt]="startAt"
  [theme]="theme"
  [timezone]="timezone"
  [queueId]="queueId"
  [queueName]="queueName"
></app-waiting>
